import React, { useMemo } from 'react';
import { observer, useAsObservableSource } from 'mobx-react-lite';
import { SelectState } from './Select.state';
import {
    SelectWrapper,
    SelectLabel,
    SelectElement,
    EmptyOption
} from './Select.styles';

export interface SelectOptionsType {
    [key: string]: string
}

interface SelectPropsTypes {
    className?: string,
    name: string,
    options: SelectOptionsType,
    label?: string,
    state: SelectState
}

export const Select = observer((propsIn: SelectPropsTypes): JSX.Element => {
    const props = useAsObservableSource(propsIn);
    const { className, name, options, label, state } = props;

    const optionsArray = useMemo(() => Object.keys(options), [options]);

    const onChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        state.value = event.currentTarget.value;
    };

    return (
        <SelectWrapper className={className}>
            {label && <SelectLabel>{label}</SelectLabel>}
            <SelectElement
                name={name}
                value={state.currentValue}
                onFocus={state.handleFocus}
                onBlur={state.handleBlur}
                onChange={onChange}
            >
                <EmptyOption key={`first${name}`} value='' disabled hidden selected />
                {
                    optionsArray.map((value: string) => {
                        //@ts-expect-error
                        const optionLabel: string = options[value];
                        return (
                            <option key={value} value={value}>
                                {optionLabel}
                            </option>
                        );
                    })
                }
            </SelectElement>
        </SelectWrapper>
    );
});
